import {
  Brain,
  CalendarDays,
  CheckCircle2,
  ChevronRight,
  Gift,
  Image,
  PackageCheck,
  Printer,
  ShieldCheck,
  Sparkles,
  Star,
  Truck,
  WandSparkles,
} from 'lucide-react';

export const navItems = [
  { label: 'Produkty', href: '#products' },
  { label: 'Jak to funguje', href: '#how-it-works' },
  { label: 'Inspirace', href: '#inspiration' },
  { label: 'O nás', href: '#about' },
  { label: 'Blog', href: '#footer' },
];

export const trustItems = [
  { icon: Printer, title: 'Prémiová kvalita tisku', text: 'na FineArt papíry' },
  { icon: CalendarDays, title: 'České svátky a jmeniny', text: 'v každém kalendáři' },
  { icon: Sparkles, title: 'AI vybere nejlepší', text: 'momenty' },
  { icon: Truck, title: 'Doprava zdarma', text: 'od 999 Kč' },
];

export const steps = [
  { number: '01', icon: CheckCircle2, title: 'Vyber typ kalendáře', text: 'Zvol formát a styl, který se ti hodí.' },
  { number: '02', icon: WandSparkles, title: 'AI vybere momenty', text: 'Umělá inteligence vybere tvé nejlepší fotky.' },
  { number: '03', icon: PackageCheck, title: 'Doladíš a objednáš', text: 'Přizpůsobíš design a my vytiskneme s prémiovou péčí.' },
];

export const products = [
  {
    id: 'basic_year_story',
    title: 'Basic Year Story',
    text: 'Klasický nástěnný kalendář z nejkrásnějších momentů.',
    image: 'products/product_basic_year_story',
    href: '/start?product=basic_year_story',
  },
  {
    id: 'family_planner_cz',
    title: 'Family Planner CZ',
    text: 'Rodinný plánovací kalendář se svátky a jmeninami.',
    image: 'products/product_family_planner_cz',
    href: '/start?product=family_planner_cz',
  },
  {
    id: 'fineart_gallery',
    title: 'FineArt Gallery',
    text: 'Prémiový kalendář na FineArt papírech v galerijní kvalitě.',
    image: 'products/product_fineart_gallery',
    href: '/start?product=fineart_gallery',
  },
];

export const features = [
  { icon: Brain, title: 'AI výběr fotek', text: 'Chytrý výběr těch nejlepších snímků z celé galerie.' },
  { icon: CalendarDays, title: 'České svátky a jmeniny', text: 'Přesná kalendářní data pro ČR připravená pro tisk.' },
  { icon: Printer, title: 'Prémiová kvalita tisku', text: 'Tisk na kvalitních papírech s důrazem na detail.' },
  { icon: CalendarDays, title: 'Libovolný start měsíce', text: 'Kalendář může začít v lednu, září nebo kdykoli během roku.' },
];

export const materials = [
  {
    title: 'FineArt print',
    text: 'Galerijní papíry pro fotografie s hloubkou detailu.',
    image: 'materials-ecosystem/material_fineart_print',
  },
  {
    title: 'GlassKit',
    text: 'Prémiové skleněné a akrylové objekty pro další fázi.',
    image: 'materials-ecosystem/material_glasskit',
  },
  {
    title: 'Dárkové packaging',
    text: 'Prémiové balení pro dárkový první dojem.',
    image: 'materials-ecosystem/material_premium_packaging',
  },
  {
    title: 'Mobilní aplikace',
    text: 'Tvoř a spravuj kalendáře snadno z mobilu.',
    image: 'materials-ecosystem/material_mobile_app',
  },
];

export const inspiration = [
  'inspiration/inspiration_01',
  'inspiration/inspiration_02',
  'inspiration/inspiration_03',
  'inspiration/inspiration_04',
  'inspiration/inspiration_05',
  'inspiration/inspiration_06',
];

export const testimonials = [
  { name: 'Petra K.', city: 'Praha', text: 'Krásný kalendář, úžasná kvalita tisku a rychlé dodání. AI výběr fotek mi ušetřil hodiny práce.' },
  { name: 'Markéta S.', city: 'Brno', text: 'Family Planner CZ nám pomohl mít přehled o celé rodině. Svátky a jmeniny jsou skvělý detail.' },
  { name: 'Lukáš V.', city: 'Ostrava', text: 'FineArt kvalita je opravdu znát. Kalendář vypadá jako obraz na zdi.' },
];

export const faq = [
  { q: 'Jak dlouho trvá výroba a doručení?', a: 'Standardně počítejte s výrobou v řádu několika pracovních dní podle sezóny a typu produktu. Přesný termín se zobrazí v objednávce.' },
  { q: 'Mohu začít kalendář libovolným měsícem?', a: 'Ano. Calendar Studio je navržené tak, aby kalendář mohl začít v lednu, září nebo kterýmkoli měsícem v roce.' },
  { q: 'Jaké formáty kalendářů nabízíte?', a: 'MVP pracuje se třemi řadami: Basic Year Story, Family Planner CZ a FineArt Gallery. Další formáty budou přidány postupně.' },
  { q: 'Jak funguje AI výběr fotek?', a: 'První verze používá chytrý výběr podle rozlišení, orientace, data, duplicit a základní kvality. Generativní AI není povinná součást MVP.' },
  { q: 'Jsou v kalendáři české svátky a jmeniny?', a: 'Ano, Family Planner CZ i další české varianty počítají s českými svátky a jmeninami.' },
  { q: 'Mohu kalendář upravit i v mobilu?', a: 'Ano. Homepage i budoucí editor jsou navržené mobil-first, protože fotky jsou nejčastěji v telefonu.' },
];

export const footerColumns = [
  { title: 'Produkty', links: ['Basic Year Story', 'Family Planner CZ', 'FineArt Gallery', 'Všechny produkty'] },
  { title: 'Podpora', links: ['Kontakt', 'Doprava a platba', 'Reklamace', 'FAQ'] },
  { title: 'O nás', links: ['O Calendar Studio', 'Blog', 'Kariéra', 'Pro partnery'] },
];

export const smallIcons = { ChevronRight, Gift, Image, ShieldCheck, Star };
